import { Node, mergeAttributes } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-3';
import { EmbeddedLiteYoutubeEditor } from '@/components/tiptap';

export const LiteYoutubeNode = Node.create({
  name: 'liteYoutube',
  group: 'block',
  atom: true,

  addAttributes() {
    return {
      src: {
        default: '',
      },
    };
  },
  parseHTML() {
    return [
      {
        tag: 'embedded-lite-youtube',
      },
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ['embedded-lite-youtube', mergeAttributes(HTMLAttributes)];
  },
  addNodeView() {
    return VueNodeViewRenderer(EmbeddedLiteYoutubeEditor);
  },
});
